<div *ngIf="productsList">
    <ul>
        <li *ngFor="let product of productsList">
            <app-card [productDetails]="product"></app-card>
        </li>
    </ul>
</div>
